import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
// @ts-ignore
import { makeSelectValuesTimesheetEntryValue } from 'services/timesheetTimesheetEntriesForm/selectors';

const selectEntityId = createDeepEqualSelector(
    makeSelectValuesTimesheetEntryValue('entityCompositeKey'),
    (entityCompositeKey: string | undefined) => {
        if (entityCompositeKey) {
            const [entityId] = entityCompositeKey.split('.');

            return Number(entityId);
        }

        return undefined;
    }
);

const makeSelectEntityId = (): typeof selectEntityId => selectEntityId;

export { makeSelectEntityId };
